/*
 * Global Scripts
 */

document.addEventListener('DOMContentLoaded', function(){

	/* Cookies
	======================================== */
	const cookies = $('#cookies-wrapper');
	if(localStorage.getItem('cookies')){
		cookies.remove()
	}
	$('.cookies-trigger').on('click', function(){
		var choice = $(this).data('value');
		if(!$('body').hasClass('transition')){
			$('body').addClass('transition');
			cookies.fadeOut(400, 'easeInOutQuint', function(){
				localStorage.setItem('cookies', choice);
				$('body').removeClass('transition');
			});
		}
	});

	/* Submenus
	======================================== */
	$('.trigger-submenu').on('click', function(){
		var t = $(this),
			 menu = $('#submenu-'+t.data('menu'));
		var submenu = t.parent().find('.submenu__container_mobile');
		if(menu.length && !$('.submenu.transition').length){
			menu.addClass('transition')
			if($('.submenu').not(menu).is(':visible')){
				$('.trigger-submenu').removeClass('active')
				t.addClass('active')
				submenu.addClass('active')
				$('.menu:visible').slideUp(400, 'easeInOutQuint', function(){
					menu.slideDown(400, 'easeInOutQuint', function(){
						menu.removeClass('transition')
					});
				});
			}else{
				t.toggleClass('active')
				submenu.toggleClass('active')
				menu.slideToggle(400, 'easeInOutQuint', function(){
					menu.removeClass('transition')
				});
			}
		}
	});


	/* Minicart
	==================================== */
	const
		cart = $('#minicart-wrapper'),
		cartTrigger = $('#minicart-trigger');
	function toggleCart(){
		if(!$('body').hasClass('transition')){
			$('body').addClass('transition')
			cartTrigger.toggleClass('active')
			cart.toggle('slide', {
				direction: 'right',
				speed: 400,
				easing: 'easeInOutQuart',
				complete: function(){
					$('body').removeClass('transition')
				}
			})
		}
	}
	$('#minicart-trigger, #minicart-close').on('click', function(e){
		e.stopPropagation()
		toggleCart()
	})
	cart.on('click', function(e){
		e.stopPropagation()
	});
	$(document).on('keydown', function(e){
		if(e.key === 'Escape' && cartTrigger.hasClass('active')){
			// toggleCart()
		}
	}).on('click', function(){
		if(cartTrigger.hasClass('active')){
			// toggleCart()
		}
	})

	function toggleScroll() {
		let scroll = $(window).scrollTop();
		let body = $('body');
	  
		if (scroll > 50) {
		  	body.addClass('scroll');
		} else {
		  	body.removeClass('scroll');
		}
	}
	  
	$(window).on('scroll', toggleScroll);

	function timer() {
		let countDownDate = new Date('Oct 20, 2023 16:00:00').getTime();

		let x = setInterval(function() {
			let now = new Date().getTime();
			let distance = countDownDate - now;
			let days = Math.floor(distance / (1000 * 60 * 60 * 24));
			let dias = (days < 10) ? '0' + days : days;
			let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			let horas = (hours < 10) ? '0' + hours : hours;
			let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			let minutos = (minutes < 10) ? '0' + minutes : minutes;
			let seconds = Math.floor((distance % (1000 * 60)) / 1000);
			let segundos = (seconds < 10) ? '0' + seconds : seconds;

			document.getElementById('timer').innerHTML = dias + ' : ' + horas + ' : ' + minutos + ' : ' + segundos;

			if (distance < 0) {
				clearInterval(x);
				document.getElementById('timer').innerHTML = '';
			}
		}, 1000);
	}

	if ($('body').hasClass('template-countdown')) {
		timer();

		setInterval(function() {
			$('body').toggleClass('scroll')
		}, 5000)
	};

	$('#back-to-top').on('click', function() {
		$('html, body').animate({ scrollTop: 0 }, 'slow');
	});

	$('.credits-trigger').on('click', function() {
		$('body').addClass('show-credits');
	});

	$('.credits-close').on('click', function() {
		$('body').removeClass('show-credits');
	});

	$('.button--privacy').on('click', function() {
		$('.legal').toggleClass('active');
	});

	$('.button--close-privacy').on('click', function() {
		$('.legal').removeClass('active');
	});

	$('.banner-close').on('click', function() {
		$('body').addClass('hide-banner');
		localStorage.setItem('banner', 'hidden');
	})

	if (document.querySelector('.banner')) {
		$('.banner').prependTo('.header');
	}

	if (localStorage.getItem('banner') == 'hidden' || !document.querySelector('.banner')) {
		$('body').addClass('banner-hidden');
	}

	$('.button-menu').on('click', function() {
		let button = $(this)

		if ($('body').hasClass('show-menu')) {
			$('body').removeClass('show-menu')
			button.text('Menu')
		} else {
			$('body').addClass('show-menu')
			button.text('Close')
		}
	})
});